module.exports = __webpack_public_path__ + "static/media/tier-2.72e6724b.jpg";